common.View.create('canvas.blocks.custom.pageSlider.Block', {
    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        let swiperEl = this.element.find('.pageSwiper');

        if (swiperEl.data('swiper-enabled') === false) {
            return;
        }

        new Swiper('.pageSwiper', {
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
            },
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                375: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            },
            mousewheel: {
                releaseOnEdges: true,
                sensitivity: 1,
                invert: false,
            },
        });
    },
});
